import { ConstructionElement } from "../../../controllers/types";
import { generateID } from "../../helpers/generateID";
import { Color, TireRackItemI } from "../../types/store";
import { useStoreRoom } from "../../useStoreRoom";
import { isNewSite } from "../../../utils";
import { useShelvingStore } from "../../useShelvingStore";

export const addTireRack = (construction: ConstructionElement): TireRackItemI[] => {
    const isNew = isNewSite();
    const colorsItems = useShelvingStore.getState().colorsItems;
    const color: Color = colorsItems.tireRacks ?? colorsItems.brackets;

    const tireRacks: TireRackItemI[] = [...useStoreRoom.getState().tireRacks];
    const roomLength = useStoreRoom.getState().length;
    const roomDepth = useStoreRoom.getState().depth;

    let bitrixId = construction.BITRIX_OFFER_ID;
    let partsPrice = construction.PARTS?.reduce((acc, part) => acc + (part.price || 0), 0) || 0;
    let totalCost = construction.PRICE + partsPrice;

    if (isNew && construction?.newNomenkl) {
        // @ts-ignore
        const newNomenkl = construction.newNomenkl?.find((n) => n?.color === color);
        if (newNomenkl) {
            bitrixId = +newNomenkl.bitrixId;
            totalCost = +(newNomenkl.priceNomenkl || 0);
        }
    }

    const tireRack: TireRackItemI = {
        id: generateID(),
        type: "tire_rack_system",
        position: [0, 0, roomDepth / 2000 - parseInt(construction.PROPERTIES.DEPTH) / 2000],
        rotation: [0, 0, 0],
        name: construction.NAME,
        nameNomenkl: construction.nameNomenkl,
        config: {
            model_name: construction.CODE,
            spacing: { x: 400, y: 400 },
            url: construction.PROPERTIES.FILE_3D,
        },
        depth: parseInt(construction.PROPERTIES.DEPTH),
        height: parseInt(construction.PROPERTIES.HEIGHT),
        width: parseInt(construction.PROPERTIES.WIDTH),
        pricing: {
            base_price: isNew ? totalCost : construction.PRICE,
            total_cost: totalCost,
        },
        bitrixId,
        parts: isNew ? [] : construction.PARTS,
        category: construction.PROPERTIES.CATEGORY,
        mounting: construction.PROPERTIES.MOUNTING,
        shelfType: construction.PROPERTIES.SHELF_TYPE,
        rackType: construction.PROPERTIES.TYPE,
    };

    tireRacks.push(tireRack);
    return tireRacks;
};
